import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ZoomIn } from "lucide-react";
import styles from "./Gallery.module.css";
import { highlightGoldCoast } from "../../utils/highlightGoldCoast";

const galleryImages = [
  // Outside surroundings / property
  { id: 1, category: "Property", src: "/images/arabella.jpg", title: "Entrance" },
  { id: 2, category: "Property", src: "/images/ARB. 5.jpg", title: "Front Entrance" },
  { id: 3, category: "Property", src: "/images/ARB. 3.jpg", title: "Reception" },
  { id: 4, category: "Property", src: "/images/img2.jpg", title: "On-Site Parking" },
  { id: 5, category: "Property", src: "/images/img1.jpg", title: "Courtyard" },
  { id: 6, category: "Property", src: "/images/arabella-motor-inn.jpg", title: "Guest Courtyard" },
  { id: 7, category: "Property", src: "/images/Arb. 1.jpg", title: "Saltwater Pool" },
  { id: 8, category: "Property", src: "/images/ARB. 9.jpg", title: "Pool and Courtyard" },
  { id: 9, category: "Property", src: "/images/ARB. 7.jpg", title: "Aerial View" },
  // Rooms with beds visible only
  { id: 20, category: "Rooms", src: "/images/gallery/thumbs/queen-img8.webp", full: "/images/gallery/full/queen-img8.webp", title: "Queen Bedroom" },
  { id: 36, category: "Rooms", src: "/images/gallery/thumbs/queen-img2.webp", full: "/images/gallery/full/queen-img2.webp", title: "Queen Bed" },
  { id: 24, category: "Rooms", src: "/images/gallery/thumbs/twin-img3.webp", full: "/images/gallery/full/twin-img3.webp", title: "Twin Bedroom" },
  { id: 31, category: "Rooms", src: "/images/gallery/thumbs/family-img2.webp", full: "/images/gallery/full/family-img2.webp", title: "Family Bedroom" },
  { id: 34, category: "Rooms", src: "/images/gallery/thumbs/family-img5.webp", full: "/images/gallery/full/family-img5.webp", title: "Family Room Beds" },
  { id: 35, category: "Rooms", src: "/images/gallery/thumbs/family-img6.webp", full: "/images/gallery/full/family-img6.webp", title: "Single Bedroom" },
  { id: 42, category: "Rooms", src: "/images/ARB. 2.jpg", title: "Motel Bedroom" },
];

const categories = ["All GALLERY PHOTOS"];

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredImages = galleryImages;

  return (
    <div className={styles.pageWrapper}>
      {/* --- HERO HEADER --- */}
      <motion.div
        className={styles.heroSection}
        style={{ backgroundImage: 'url("/images/Arb. 1.jpg")' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className={styles.heroOverlay}>
          <motion.h1
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            OUR GALLERY
          </motion.h1>
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            {highlightGoldCoast(
              "A visual journey through the elegance of Arabella on the Tweed Heads South, NSW. The photos take in the queen, deluxe, twin, and family rooms, complimentary parking, and the outdoor saltwater pool for guests looking at accommodation Tweed Heads."
            )}
          </motion.p>
        </div>
      </motion.div>

      <div className={styles.container}>
        {/* --- FILTER TABS (Static Label) --- */}
        <div className={styles.filterRow}>
          {categories.map((cat) => (
            <div
              key={cat}
              className={`${styles.filterBtn} ${styles.activeBtn}`}
              style={{ cursor: "default" }}
            >
              {cat}
            </div>
          ))}
        </div>

        {/* --- IMAGE GRID --- */}
        <motion.div layout className={styles.galleryGrid}>
          <AnimatePresence>
            {filteredImages.map((img) => (
              <motion.div
                layout
                key={img.id}
                className={styles.imageCard}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.4 }}
                onClick={() => setSelectedImage(img)}
              >
                <div className={styles.imgWrapper}>
                  <img src={img.src} alt={img.title} loading="lazy" decoding="async" />
                  <div className={styles.overlay}>
                    <ZoomIn size={32} color="white" />
                    <span>{img.title}</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>

      {/* --- LIGHTBOX MODAL --- */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className={styles.lightbox}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              className={styles.lightboxContent}
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className={styles.closeBtn}
                onClick={() => setSelectedImage(null)}
              >
                <X size={24} />
              </button>
              <img src={selectedImage.full || selectedImage.src} alt={selectedImage.title} />
              <h3>{selectedImage.title}</h3>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Gallery;
